import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import GameList from "./components/GameList";
import Header from "./components/Header";
import SignInPage from "./components/SignInPage";
import { Container } from "@mui/material";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase/firebaseConfig";
import MagicLinkHandler from "./components/MagicLinkHandler";
import PastEncounters from "./components/PastEncounters";
import AdminPanel from "./components/AdminPanel";
import Settings from "./components/Settings";


const App = () => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState("user");
  const [updatePastEncounters, setUpdatePastEncounters] = useState(() => () => {});
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        console.log("🔹 Nutzer angemeldet:", currentUser); // Debugging
        setUser(currentUser);
  
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
        setRole(userSnap.exists() ? userSnap.data().role : "user");
  
      } else {
        setUser(null);
        setRole("user");
      }
    });
  
    return () => unsubscribe();
  }, []);
  
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js")
        .then(registration => {
          console.log("✅ Service Worker erfolgreich registriert:", registration);
        })
        .catch(error => {
          console.error("❌ Fehler beim Registrieren des Service Workers:", error);
        });
    }
  }, []);
  

  return (
    <Router>
      <Header user={user} role={role} updatePastEncounters={setUpdatePastEncounters} />
      <Container sx={{ mt: 4 }}>
        <Routes>
          <Route path="/" element={<GameList user={user} role={role} />} />
          <Route path="/login" element={<SignInPage />} />
          <Route path="/magic-login" element={<MagicLinkHandler setUser={setUser} setRole={setRole} />} />
          <Route path="/past-encounters" element={<PastEncounters updatePastEncounters={updatePastEncounters} />} />
          <Route
            path="/admin"
            element={role === "admin" ? <AdminPanel user={user} role={role} /> : <Navigate to="/" />}
          />
           <Route path="/settings" element={<Settings />} />
        </Routes>
      </Container>
    </Router>
  );
};

export default App;
